<template>
    <div>
        <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
        <b-card>
            <b-row class="mb-2 align-items-center">
                <b-col cols="8">
                    <h3 class="mr-50">
                    <feather-icon size="20" icon="FileIcon" />
                    إجرائيات المعاملات
                    </h3>
                    

                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">

                    <data-table ref="transactionDescriptionTable" ep="v2/ministry/action-types" striped :fields="fields">
                        
                        <template #cell(type)="{ value }">
                            
                            <b-badge v-if="value === 0" variant="light-success"> داخلية </b-badge>
                            <b-badge v-else variant="light-danger"> خارجية </b-badge>
                        </template>
                        <template #cell(is_announcement)="{ value }">
                            
                            <b-badge v-if="value === 1" variant="light-secondary"> نعم </b-badge>
                            <b-badge v-else variant="light-secondary"> لا </b-badge>
                        </template>
                        <template #cell(actions)="row">
                            <div class="d-flex align-items-center justify-content-end">
                            <b-button
                                variant="flat-info"
                                @click="id=row.item.id; row.toggleDetails()"
                                title="عرض المزيد من المعلومات"
                                size="sm"
                                class="btn-icon rounded-circle"
                                v-b-tooltip.hover.v-info.top
                            >
                                <feather-icon icon="InfoIcon" size="1.8x" color="#82868b" />
                            </b-button>
                            </div>
                        </template>
                        <template #row-details="row">
                            <b-card  v-show="id === row.item.id">
                            <b-row class="mb-2">
                                <b-col md="12" class="mb-1 d-flex">
                                <div>
                                    <strong>إجرائيات المعاملة :</strong>
                                </div>
                                </b-col>
                                <b-col cols="12">

                                    <div class="text-info mx-1">
                                        <div v-if="loading" >
                                            <b-skeleton width="1500px"  height="300px"  ></b-skeleton>
                                        </div>
                                        <div v-else>
                                            <app-timeline>
                                                <app-timeline-item
                                                    variant="secondary"
                                                    v-for="item in TransactionActions"
                                                >
                                                    <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                                                    <h5>  {{ item.description }}</h5>
                                                    </div>
                                                    <b-row
                                                    class="d-flex justify-content-between align-items-center bg-transparent"
                                                    >
                                                    <b-col md="4" cols="4"><p> <feather-icon icon="UserIcon" size="17" class="mx-25" /> دور الموظف الذي يقوم بهذا الإجراء  : <span>{{ item.transactionRole.name }}</span></p></b-col>
                                                    <b-col md="4" cols="4" class="d-flex justify-content-end"><p> <feather-icon icon="CalendarIcon" size="17" class="mx-25" />  عدد الأيام اللازمة لتنفيذ الإجراء  : <span> {{ item.days_number }}</span></p></b-col>
                                                    <b-col md="4" cols="4" class="d-flex justify-content-end">
                                                      <p>
                                                        <b-button
                                                          variant="outline-info"
                                                          type="submit"
                                                          size="sm"
                                                          pill
                                                          @click="onClickEditTransactionActions(item)"
                                                        >
                                                         <feather-icon icon="EditIcon"  size="17" class="mx-25" />
                                                        </b-button>

                                                      </p>
                                                    </b-col>
                                                        
                                                    
                                                    </b-row>
                                                </app-timeline-item>
                                            </app-timeline>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
            
                            <b-button
                                size="sm"
                                variant="outline-secondary"
                                @click="row.toggleDetails"
                            >
                                عرض اقل
                            </b-button>
                            </b-card>
                        </template>
                    </data-table>
                </b-col>

            </b-row>

        </b-card>
        <b-modal
          v-model="editModal"
          footer-class="removed"
          centered
          no-close-on-backdrop
          v-bind="$attrs"
          v-on="$listeners"
          title="تعديل معلومات الإجراء"
        >
        <div>
            <validation-observer ref="actionValidation">
                
                <b-form @submit.prevent>
                    <b-row>
                        <b-col cols="12">
                        
                          <validation-provider
                              #default="{ errors }"
                              name="description"
                              rules="required"
                              >
                              <form-textarea
                                  class="my-1"
                                  label="وصف الإجراء"
                                  rules="required"
                                  v-model="form.description"
                                />
            
                              <small class="text-danger">{{
                                  errors[0] ? "الحقل مطلوب" : ""
                              }}</small>
                          </validation-provider>
                        </b-col>
                        <b-col cols="12">
                            <validation-provider
                                #default="{ errors }"
                                name="days_number"
                                rules="required|integer|min:1|max:2"
                                >
                                <form-input
                                    v-if="form"
                                    v-model="form.days_number"
                                    rules="required|integer|min:1|max:2"
                                    label="عدد الأيام اللازمة لتنفيذ الإجراء"
                                />
                                <small class="text-danger">{{
                                    errors[0] ? "الحقل يجب أن يكون عدداَ صحيحاً و أن يحتوي على 2 حروف على الأكثر" : ""
                                }}</small>
                            </validation-provider>
                        </b-col>
                    
                    </b-row>
                    <hr />
                    <b-row class="px-1 my-1 justify-content-end">
                        <b-button @click="editModal = false" class="mx-1">إلغاء</b-button>
                        <loader-btn
                            variant="success"
                            @click="onConfirmEdit"
                            :loading="loadingUpdate"
                            label="تعديل"
                            loadingLabel="جاري التعديل ..."
                            
                        ></loader-btn>
                    </b-row>
                </b-form>
            </validation-observer>
        </div>

      </b-modal>
    </div>
</template>
<script>
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { BCard , BRow , BCol , BSkeleton , BButton , BDropdown , BDropdownItem , BBadge , BForm , BModal } from "bootstrap-vue";
import FormInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import FormCleave from "@/components/FormCleave";
import DataTable from "@/components/data-table";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import { mapActions, mapGetters } from "vuex";
import loaderBtn from "@/components/loader-btn";
import { VBTooltip } from "bootstrap-vue";
import { required , min , integer } from "@validations";
import { ValidationProvider, ValidationObserver  } from "vee-validate";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.snow.css";
export default {
  components: {
    MinistryBreadcrumbs , BCard , DataTable , BRow , BCol , BSkeleton , BButton , BDropdown , BDropdownItem , BBadge , BForm , loaderBtn , quillEditor , ValidationProvider, ValidationObserver , FormInput , FormCleave 
    , AppTimeline, AppTimelineItem , BModal , formTextarea
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
    id: null ,
    editModal : false ,
    form : {} ,
    editorOption: {
    modules: {
        toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['link'],
        ]
    }
    },
      mainTitle: "إدارة المعاملات",
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "إجرائيات المعاملات",
          active: true,
        },
      ],
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "name",
          label: "اسم المعاملة",
        },
        {
          key: "is_announcement",
          label: "معاملة إعلام / ليست معاملة إعلام ؟",
        },
        {
          key: "type",
          label: "داخلية / خارجية ؟",
        },
        {
          key: "priority",
          label: "الأولوية",
        },
        {
          key: "total_duration",
          label: "المدة اللازمة لتنفيذ المعاملة",
        },
        { key: "actions", label: " " },
      ],
      
    };
  },
  computed: {
    ...mapGetters("Ministry/Settings/TransactionManagement", ["TransactionActions" , "loading" , "loadingUpdate"]),
  },
  methods:{
    ...mapActions("Ministry/Settings/TransactionManagement", ["fetchTransactionActionsById" , "updateTransactionActionsById"]),
    onClickEditTransactionActions(actions){
      this.form.id = actions.id
      this.form.days_number = actions.days_number
      this.form.description = actions.description
      this.editModal = true
    },
    async onConfirmEdit(){
      await this.updateTransactionActionsById(this.form).then(response => {
        this.editModal = false
        // this.fetchTransactionActionsById(this.id)
        this.form = {}
        this.$refs.transactionDescriptionTable.refreshTable();
      })
    },
  },
  watch:{
    async id(val) {
        await this.fetchTransactionActionsById(val)
        
    },
   
   }
};
</script>